<div
  [ngClass]="{'fullScreen': isFullScreenMode}"
  infinite-scroll
  [scrollWindow]="true"
  [infiniteScrollContainer]="scrollContainer"
  [fromRoot]="true"
  [infiniteScrollDistance]="distance"
  [infiniteScrollThrottle]="throttle"
  [infiniteScrollDisabled]="isLoadingInProgress"
  (scrolled)="onScroll()"
>
  <div class="cardsRow">
    <ng-container *ngFor="let dprCard of dprCards; trackBy: trackDprCard">
      <app-dpr-card
        class="d-flex flex-column"
        [data]="dprCard"
        [canEdit]="canEdit"
        [approvers]="approvers"
        [onlineApprovers]="onlineApprovers"
        [accountId]="accountId"
        [clientId]="clientId"
        [clientName]="clientName"
        [isDigitalSignatureEnabled]="isDigitalSignatureEnabled"
        [canEditExternalPartyComment]="canEditExternalPartyComment"
        [customNames]="customNames"
        [isAppOnline]="isAppOnline"
      ></app-dpr-card>
    </ng-container>
  </div>
</div>
